module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Regular-07ddc24bb3f535ef475eb429b6f4e82e.woff2";